const productNames = {
  '4': 'Dental',
  '5': 'Vision',
  '7': 'Fixed Benefit Medical',
  '6': 'Short Term Medical',
  '8': 'Bridge to Medicare',
  '12': 'Supplemental',
  '11': 'Short Term Medical',
  '13': 'Short Term Medical',
  '14': 'Short Term Medical',
  '15': 'Short Term Medical',
  '16': 'Short Term Medical'
}

function getCoverageType(productName: string): string {
  switch (productName) {
    case 'Short Term':
      return 'Short Term Medical - STM'
    case 'Short Term Medical':
      return 'Short Term Medical - STM'
    case 'Bridge to Medicare':
      return 'Short Term Medical - STM'
    case 'Supplemental':
      return 'Supplemental - Latitude'
    default:
      return productName
  }
}

export { getCoverageType, productNames }
